// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".module[data-v-5f7839ba]{margin-bottom:100px}@media only screen and (max-width:599.98px){.module[data-v-5f7839ba]{margin-bottom:50px}.module h2[data-v-5f7839ba]{font-size:1.5rem!important}}", ""]);
// Exports
module.exports = exports;
